<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header main-card-header">
        <span>Declaration</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="main-card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
          style="padding: 30px;"
        >
          <b-row>
            <b-col xl="6" lg="6" md="12">
              <b-card>
                <div slot="header">
                  <span class="title">HEALTH DECLARATION</span>
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseYTe
                      v-b-tooltip.hover
                      :title="'hide/show'"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>
                <b-collapse id="collapseYTe" visible>
                  <b-row>
                    <b-col md="12">
                        <el-form-item
                            label="In the past 14 days, which country (countries) / territory (territories) have you been to? "
                            prop="y_te.danh_sach_quoc_gia_da_den"
                        >
                            <el-select
                                v-model="mData.dataForm.y_te.danh_sach_quoc_gia_da_den"
                                placeholder="Choose one or more"
                                multiple
                                filterable
                                auto-complete="off"
                                @input="forceUpdateUI"
                            >
                                <el-option
                                    v-for="item in mData.dataDefault.listQuocGia"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="
                                    item.ten_quoc_gia && item.ten_quoc_gia.en
                                        ? item.ten_quoc_gia.en
                                        : ''
                                    "
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </b-col>
                    <b-col md="12">
                        <el-form-item
                            label="In the past 14 days, did you have any of these following symptoms?"
                            prop="y_te.danh_sach_dau_hieu"
                        >
                            <el-select
                                v-model="mData.dataForm.y_te.danh_sach_dau_hieu"
                                placeholder="Keep blank if you did not have any symptom"
                                multiple
                                filterable
                                auto-complete="off"
                                @input="forceUpdateUI"
                            >
                                <el-option
                                    v-for="item in mData.dataDefault.listDauHieu"
                                    :key="item.value"
                                    :value="item.value"
                                    :label="item.name"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </b-col>
                    <b-col md="12">
                        <el-form-item
                            label="In the past 14 days, have you been exposed to"
                            prop="y_te.danh_sach_tiep_xuc"
                        >
                            <el-select
                                v-model="mData.dataForm.y_te.danh_sach_tiep_xuc"
                                placeholder="Keep blank if you have not been exposed to"
                                multiple
                                filterable
                                auto-complete="off"
                                @input="forceUpdateUI"
                            >
                                <el-option
                                    v-for="item in mData.dataDefault.listKBYTTiepXuc"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="item.ten && item.ten.en ? item.ten.en : ''"
                                    class="custom-select-break-line"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </b-col>
                    <b-col md="12">
                        <el-form-item
                            label="Which of the following diseases do you currently have?"
                            prop="y_te.danh_sach_benh"
                        >
                            <el-select
                                v-model="mData.dataForm.y_te.danh_sach_benh"
                                placeholder="Keep blank if you did not have any disease"
                                multiple
                                filterable
                                auto-complete="off"
                                @input="forceUpdateUI"
                            >
                                <el-option
                                    v-for="item in mData.dataDefault.listKBYTBenh"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="item.ten && item.ten.en ? item.ten.en : ''"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </b-col>
                    <b-col md="12">
                        <el-form-item label="Body temperature (Use '.' for temperature, ex: 36.5)" prop="y_te.than_nhiet">
                            <el-input
                                class="text-center"
                                v-model="mData.dataForm.y_te.than_nhiet"
                                auto-complete="off"
                                @input="forceUpdateUI"
                            ></el-input>
                        </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
            <b-col xl="6" lg="6" md="12">
              <b-card>
                <div slot="header">
                  <span class="title">VACCINE CERTIFICATE</span>
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseVaccine
                      v-b-tooltip.hover
                      :title="'hide/show'"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>
                <b-collapse id="collapseVaccine" visible>
                  <b-row>
                    <b-col md="12">
                      <el-form-item label="Injection Certificate" prop="loai">
                        <el-radio
                          class="mr-2"
                          v-model="mData.dataForm.loai"
                          :label="1"
                          @change="changeRadioValue(mData.dataForm.loai)"
                          >Photo</el-radio
                        >
                        <el-radio
                          class="mr-2"
                          v-model="mData.dataForm.loai"
                          :label="2"
                          @change="changeRadioValue(mData.dataForm.loai)"
                          >QR code</el-radio
                        >
                        <!-- <el-radio
                          v-model="mData.dataForm.loai"
                          :label="3"
                          @change="changeRadioValue()"
                          >Link</el-radio
                        > -->
                      </el-form-item>
                    </b-col>
                    <b-col md="12" v-show="mData.dataForm.loai == 1">
                      <el-form-item
                        label="Photo certificate"
                        prop="tiem_chung.anh_id"
                      >
                        <el-upload
                          action
                          :auto-upload="false"
                          drag
                          :limit="mData.fileUploadOption.Anh.limit"
                          :accept="mData.fileUploadOption.Anh.accept"
                          :on-change="fn_uploadChangeAnh"
                          :on-preview="fn_uploadPreviewAnh"
                          :on-remove="fn_uploadRemoveAnh"
                          :on-exceed="fn_uploadExceedAnh"
                          :file-list="mData.fileUploadOption.Anh.fileList"
                          :multiple="false"
                          :class="{ hide: mData.dataDefault.anh }"
                        >
                          <div v-if="!mData.dataDefault.anh">
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                              Drop photo here or <em>click to upload</em>
                            </div>
                          </div>
                        </el-upload>
                        <div
                          class="d-flex justify-content-center"
                          style="max-height: 400px"
                          v-if="mData.dataDefault.anh"
                        >
                          <el-image :src="mData.dataDefault.anh" lazy></el-image>
                        </div>
                      </el-form-item>
                    </b-col>
                    <!-- <b-col md="12" v-show="mData.dataForm.loai == 3">
                      <el-form-item label="Link certificate" prop="tiem_chung.link">
                        <el-input
                          v-model="mData.dataForm.tiem_chung.link"
                          auto-complete="off"
                        ></el-input>
                      </el-form-item>
                    </b-col> -->
                    <b-col md="12" v-show="mData.dataForm.loai == 2">
                      <div class="d-flex jusity-content-center" v-if="mData.dataDefault.showCamera">
                        <el-form-item label="QR code" prop="tiem_chung.qr" v-if="mData.dataForm.loai == 2">
                          <div
                            class="mb-3"
                            style="width: 300px; height: 300px"
                          >
                            <QrcodeStream @decode="onDecode" />
                          </div>
                          <!-- <el-input
                            v-model="mData.dataForm.tiem_chung.qr"
                            auto-complete="off"
                          ></el-input> -->
                        </el-form-item>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xl="7" lg="12">
                        <el-form-item label="Vaccine" prop="tiem_chung.vaccine">
                            <el-select
                                v-model="mData.dataForm.tiem_chung.vaccine"
                                @change="fn_changeVaccine()"
                                placeholder="Select"
                                :disabled="mData.dataDefault.certificateByQR"
                                @input="forceUpdateUI"
                            >
                                <el-option
                                    v-for="item in mData.dataDefault.listVaccine"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="item.ten"
                                    auto-complete="off"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </b-col>
                    <b-col xl="5" lg="12" v-if="mData.dataDefault.certificateByQR">
                        <el-form-item
                            label="Date of expiry"
                            prop="tiem_chung.gia_tri_den"
                        >
                            <el-date-picker
                                v-model="mData.dataForm.tiem_chung.gia_tri_den"
                                type="date"
                                :format="aElement.datepicker.formatDate"
                                :valueFormat="aElement.datepicker.valueFormat + '+07:00'"
                                auto-complete="off"
                                :disabled="mData.dataDefault.certificateByQR"
                                @input="forceUpdateUI"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </b-col>
                    <b-col xl="7" lg="12">
                        <el-form-item
                            label="Certificate number"
                            prop="tiem_chung.so_giay_chung_nhan"
                        >
                            <el-input
                                v-model="mData.dataForm.tiem_chung.so_giay_chung_nhan"
                                auto-complete="off"
                                :disabled="mData.dataDefault.certificateByQR"
                                @input="forceUpdateUI"
                            ></el-input>
                        </el-form-item>
                    </b-col>
                    <b-col xl="5" lg="12">
                        <el-form-item
                            label="Injection country"
                            prop="tiem_chung.quoc_gia_id"
                        >
                            <el-select
                                v-model="mData.dataForm.tiem_chung.quoc_gia_id"
                                placeholder="Choose"
                                filterable
                                auto-complete="off"
                                :disabled="mData.dataDefault.certificateByQR"
                                @input="forceUpdateUI"
                            >
                                <el-option
                                    v-for="item in mData.dataDefault.listQuocGia"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="
                                    item.ten_quoc_gia && item.ten_quoc_gia.en
                                        ? item.ten_quoc_gia.en
                                        : ''
                                    "
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row
                      v-for="(luot_tiem, index) in mData.dataForm.tiem_chung.luot_tiem"
                      :key="index"
                  >
                      <b-col xl="7" lg="12">
                          <el-form-item
                              :label="'Injection place (' + renderTimes(index) + ')'"
                              :prop="'tiem_chung.luot_tiem[' + index + '].dia_diem_tiem'"
                          >
                              <el-input
                                  v-model="luot_tiem.dia_diem_tiem"
                                  auto-complete="off"
                                  :disabled="mData.dataDefault.certificateByQR"
                                  @input="forceUpdateUI"
                              ></el-input>
                          </el-form-item>
                      </b-col>
                      <b-col xl="5" lg="12">
                          <el-form-item
                              :label="'Injection time (' + renderTimes(index) + ')'"
                              :prop=" 'tiem_chung.luot_tiem[' + index + '].thoi_gian_tiem'"
                          >
                              <el-date-picker
                                  v-model="luot_tiem.thoi_gian_tiem"
                                  type="date"
                                  :format="aElement.datepicker.formatDate"
                                  :valueFormat="aElement.datepicker.valueFormat + '+07:00'"
                                  auto-complete="off"
                                  :disabled="mData.dataDefault.certificateByQR"
                                  @input="forceUpdateUI"
                              >
                              </el-date-picker>
                          </el-form-item>
                      </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>
          <b-row class="mt-3 mb-3">
            <b-col md="12">
              <el-form-item class="text-center">
                <el-button
                  class="btn-save"
                  :disabled="checkSave()"
                  type="primary"
                  @click="fn_saveData()"
                  v-ladda
                  plain
                  >Save</el-button
                >
                <el-button
                  class="btn-submit"
                  :disabled="checkSubmit()"
                  type="primary"
                  @click="fn_submitForm()"
                  v-ladda
                  >Submit</el-button
                >
              </el-form-item>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import ForeignerQrApi from "../../../moduleApi/ForeignerQrApi";
import ForeignerApi from "../../../moduleApi/ForeignerApi";
import QuocGiaApi from "../../../moduleApi/QuocGiaApi";
import LanguageService from "../../../service/LanguageService";
import KBYTTiepXucApi from "../../../moduleApi/KBYTTiepXucApi";
import KBYTBenhApi from "../../../moduleApi/KBYTBenhApi";
import VaccineApi from "../../../moduleApi/VaccineApi";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import ValidService from '../../../service/ValidService';
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";

export default {
  components: {
    QrcodeStream,
    QrcodeDropZone,
    QrcodeCapture,
  },
  data() {
    var validateImage = (rule, value, callback) => {
      if(!value){
        callback();
      }
      if (!value && this.mData.dataForm.loai == "1") {
        callback(new Error("Please upload a photo"));
      } else {
        callback();
      }
    };
    var validateQR = (rule, value, callback) => {
      if (!value && this.mData.dataForm.loai == "2") {
        callback(new Error("Please scan QR"));
      } else {
        callback();
      }
    };
    var validateLink = (rule, value, callback) => {
      if (!value && this.mData.dataForm.loai == "3") {
        callback(new Error("Please enter link"));
      } else if (this.mData.dataForm.loai == "3" && !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(value)) {
        callback(new Error("Link is invalid"));
      } else {
        callback();
      }
    };

    let validateTemperature = (rule, value, callback) => {
      if((value != undefined && value != "") && (isNaN(value))){
        callback(new Error("Invalid temperature"));
      }else if ((value != undefined && value != "") && (value < 30 || value > 45)) {
        callback(new Error("Please enter body tempertature between 30 and 45 degree"));
      }
      else {
        callback();
      }
    };
    return {
      checkDifferenceValueByQR: false,
      noMatchName: false,
      noMatchDOB: false,
      noMatchGender: false,
      noMatchPassportNo: false,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        dataDefault: {
          camera: 'auto',
          certificateByQR: false,
          showCamera: true,
          listQuocGia: [],
          listDauHieu: [
            {
              name: "Cough",
              value: "ho",
            },
            {
              name: "Fever",
              value: "sot",
            },
            {
              name: "Shortness of breath",
              value: "kho_tho",
            },
            {
              name: "Pneumonia",
              value: "viem_phoi",
            },
            {
              name: "Sore throat",
              value: "dau_hong",
            },
            {
              name: "Tiredness",
              value: "met_moi",
            },
          ],
          listKBYTTiepXuc: [],
          listKBYTBenh: [],
          listVaccine: [],
          anh: "",
          data: null,
        },
        dataForm: {
          y_te: {
            danh_sach_quoc_gia_da_den: "",
            danh_sach_dau_hieu: "",
            danh_sach_tiep_xuc: "",
            danh_sach_benh: "",
            than_nhiet: "",
          },
          tiem_chung: {
            luot_tiem: [
              {
                thoi_gian_tiem: null,
                dia_diem_tiem: null,
              },
            ],
            vaccine: null,
            gia_tri_den: null,
            so_giay_chung_nhan: null,
            anh_id: null,
            quoc_gia_id:null,
            qr: null,
            link: null,
          },
          loai: "",
        },
        validForm: {
          loai: [
            {
              required: true,
              message: "Please choose a value",
              trigger: "blur",
            },
          ],
          "y_te.danh_sach_quoc_gia_da_den": [
            // {
            //   required: true,
            //   message: "Please choose a value",
            //   trigger: "blur",
            // },
          ],
          "y_te.danh_sach_dau_hieu": [
            // {
            //   required: true,
            //   message: "Please choose a value",
            //   trigger: "blur",
            // },
          ],
          "y_te.danh_sach_tiep_xuc": [
            // {
            //   required: true,
            //   message: "Please choose a value",
            //   trigger: "blur",
            // },
          ],
          "y_te.danh_sach_benh": [
            // {
            //   required: true,
            //   message: "Please choose a value",
            //   trigger: "blur",
            // },
          ],
          "y_te.than_nhiet": [
            {
              validator: validateTemperature,
              trigger: "blur",
            },
            // {

            //   message: "Invalid value",
            //   trigger: "blur",
            // }
          ],
          "tiem_chung.luot_tiem[0].thoi_gian_tiem": [
            {
              required: true,
              message: "Please enter a value",
              trigger: "blur",
            },
            {
              validator: this.validateNgayHetHan,
              trigger: "blur",
            },
          ],
          "tiem_chung.luot_tiem[0].dia_diem_tiem": [
            {
              required: true,
              message: "Please enter a value",
              trigger: "blur",
            },
            ValidService.checkSpaceString
          ],
          "tiem_chung.luot_tiem[1].thoi_gian_tiem": [
            {
              required: true,
              message: "Please enter a value",
              trigger: "blur",
            },
            {
              validator: this.validateNgayHetHan,
              trigger: "blur",
            },
          ],
          "tiem_chung.luot_tiem[1].dia_diem_tiem": [
            {
              required: true,
              message: "Please enter a value",
              trigger: "blur",
            },
            ValidService.checkSpaceString
          ],
          "tiem_chung.vaccine": [
            {
              required: true,
              message: "Please enter a value",
              trigger: "blur",
            },
          ],
          "tiem_chung.quoc_gia_id":[
                {
                required: true,
                message: "Please enter a value",
                trigger: "blur",
                },
            ],
          "tiem_chung.gia_tri_den": [
            {
              validator: this.validateNgayHetHan1,
              trigger: "blur",
            },
          ],
          "tiem_chung.so_giay_chung_nhan": [
            {
              required: true,
              message: "Please enter a value",
              trigger: "blur",
            },
            ValidService.checkSpaceString
          ],
          "tiem_chung.anh_id": [
            {
              validator: validateImage,
              trigger: "blur",
            },
          ],
          "tiem_chung.qr": [
            {
              validator: validateQR,
              trigger: "blur",
            },
          ],
          "tiem_chung.link": [
            {
              validator: validateLink,
              trigger: "blur",
            },
          ],
        },
        currentUser: JSON.parse(localStorage.getItem('currentUser')),
        fileUploadOption: {
          Anh: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
    };
  },
  methods: {
    async initData() {
      this.mData.dataForm.loai = 1;
      try {
        let res = await QuocGiaApi.list();
        this.mData.dataDefault.listQuocGia = res.result;
        let resTX = await KBYTTiepXucApi.list();
        this.mData.dataDefault.listKBYTTiepXuc = resTX.result;
        let resBenh = await KBYTBenhApi.list();
        this.mData.dataDefault.listKBYTBenh = resBenh.result;
        let resVaccine = await VaccineApi.list();
        this.mData.dataDefault.listVaccine = resVaccine.result;
        await this.getData();
      } catch (error) {}
    },
    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnh(file, fileList) {
      this.mData.dataDefault.anh = null;
      this.mData.dataForm.tiem_chung.anh_id = null;
      this.mData.fileUploadOption.Anh.fileList = [];
    },
    async fn_uploadChangeAnh(file, fileList) {
      ExtensionService.upload(file, "foreigner")
        .then((res) => {
          this.mData.dataForm.tiem_chung.anh_id = res.result;
          this.mData.dataDefault.anh =
            window.MyConfig.hostApi + "file/thumb?id=" + res.result;
        })
        .catch((error) => {
          toastr.error("An error occurred!");
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnh(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.Anh.limit} file`
      );
    },
    fn_uploadPreviewAnh(file) {
      this.mData.fileUploadOption.Anh.dialogImageUrl = file.url;
      this.mData.fileUploadOption.Anh.dialogVisible = true;
    },
    async onDecode(decodedString) {
      this.mData.dataDefault.camera = 'off';
      this.mData.dataForm.tiem_chung.qr = decodedString;
      this.noMatchName = false;
      this.noMatchDOB = false;
      this.noMatchGender = false;
      this.noMatchPassportNo = false;
      const foreignerApiRes = await ForeignerApi.findById(this.mData.currentUser.id);
      console.log("foreignerApiRes",foreignerApiRes.result);
      try {
        const checkQrCodeRes = await ForeignerQrApi.checkQrCode(this.mData.dataForm.tiem_chung.qr); 
        if(checkQrCodeRes.result && foreignerApiRes.result){
          console.log("checkQrCodeRes.result",checkQrCodeRes.result);
          if(
            (checkQrCodeRes.result.ho_ten !="" && (checkQrCodeRes.result.ho_ten.toUpperCase() !== foreignerApiRes.result.ho_chieu.ho_ten.toUpperCase())) &&
            (checkQrCodeRes.result.ngay_sinh != "" &&  (new Date(this.fomartDate(checkQrCodeRes.result.ngay_sinh)).getTime() != new Date(foreignerApiRes.result.ho_chieu.ngay_sinh).getTime()))
          ){
            window.toastr.error("Information about name, date of birth on the vaccine certificate doesn’t match the information on your passport!");
            this.mData.dataDefault.camera = 'auto';
            this.mData.dataForm.tiem_chung.qr = null;
            return
          }
          if(
            checkQrCodeRes.result.ho_ten !="" && 
            (checkQrCodeRes.result.ho_ten.toUpperCase() !== foreignerApiRes.result.ho_chieu.ho_ten.toUpperCase())
          ){
              window.toastr.error("Information about name on the vaccine certificate doesn’t match the information on your passport!");
              this.mData.dataDefault.camera = 'auto';
              this.mData.dataForm.tiem_chung.qr = undefined;
              this.noMatchName = true;
          }
          if(
              checkQrCodeRes.result.ngay_sinh != "" && 
              (new Date(this.fomartDate(checkQrCodeRes.result.ngay_sinh)).getTime() != new Date(foreignerApiRes.result.ho_chieu.ngay_sinh).getTime())
          ){
              window.toastr.error("Information about date of birth on the vaccine certificate doesn’t match the information on your passport!");
              this.mData.dataDefault.camera = 'auto';
              this.mData.dataForm.tiem_chung.qr = undefined;
              this.noMatchDOB = true;
          }
          if(
            checkQrCodeRes.result.gioi_tinh != "" && 
            (checkQrCodeRes.result.gioi_tinh !== foreignerApiRes.result.ho_chieu.gioi_tinh)
          ){
              window.toastr.error("Information about gender on the vaccine certificate doesn’t match the information on your passport!");
              this.mData.dataDefault.camera = 'auto';
              this.mData.dataForm.tiem_chung.qr = undefined;
              this.noMatchGender = true;
          }
          if(
              checkQrCodeRes.result.so_ho_chieu !="" && 
              (checkQrCodeRes.result.so_ho_chieu.toUpperCase() !== foreignerApiRes.result.ho_chieu.so_ho_chieu.toUpperCase())
            ){
              window.toastr.error("Information passport number on the vaccine certificate doesn’t match the information on your passport!");
              this.mData.dataDefault.camera = 'auto';
              this.mData.dataForm.tiem_chung.qr = undefined;
              this.noMatchPassportNo = true;
          }
          if(this.noMatchName || this.noMatchDOB || this.noMatchGender || this.noMatchPassportNo){
            return
          }
          // let checkExistedQrCodeRes = await ForeignerQrApi.checkExistedQrCode({
          //   qr:this.mData.dataForm.tiem_chung.qr
          // });
          // if(checkExistedQrCodeRes.result.length == 0 || checkExistedQrCodeRes.result[0].count == 0){
            if(checkQrCodeRes.result.thong_tin_tiem_chung.length > 0 ){
              this.mData.dataDefault.showCamera = false;
              this.mData.dataForm.tiem_chung.luot_tiem = [];
              this.mData.dataForm.tiem_chung.vaccine = checkQrCodeRes.result.thong_tin_tiem_chung[0].vaccine.id;
              this.mData.dataForm.tiem_chung.gia_tri_den = this.fomartDate(checkQrCodeRes.result.ngay_het_han);
              this.mData.dataForm.tiem_chung.so_giay_chung_nhan = checkQrCodeRes.result.so_giay_chung_nhan;
              if(checkQrCodeRes.result.thong_tin_tiem_chung[0].quoc_gia == undefined){
                this.mData.dataForm.tiem_chung.quoc_gia_id = "";
              }else{
                this.mData.dataForm.tiem_chung.quoc_gia_id = checkQrCodeRes.result.thong_tin_tiem_chung[0].quoc_gia.id;
              }
              for(let i = 0; i < checkQrCodeRes.result.thong_tin_tiem_chung.length; i++){
                  this.mData.dataForm.tiem_chung.luot_tiem.push({
                      dia_diem_tiem: checkQrCodeRes.result.thong_tin_tiem_chung[i].dia_diem_tiem,
                      thoi_gian_tiem: this.fomartDate(checkQrCodeRes.result.thong_tin_tiem_chung[i].ngay_tiem)
                  })
              }
            }
            this.checkDifferenceValueByQR = true;
            console.log("this.mData.dataForm",this.mData.dataForm);
          // }else{
          //   window.toastr.error("The vaccination certificate has been used, please try again!");
          //   this.mData.dataDefault.camera = 'auto';
          //   this.mData.dataForm.tiem_chung.qr = undefined;
          //   return
          // }
        }
      } catch (error) {
        window.toastr.error("Invalid QR!");
        return
      }
    },
    changeRadioValue(loai) {
      let propValid = ["loai","tiem_chung.luot_tiem[0].thoi_gian_tiem","tiem_chung.luot_tiem[0].dia_diem_tiem",
                        "tiem_chung.luot_tiem[1].thoi_gian_tiem","tiem_chung.luot_tiem[1].dia_diem_tiem","tiem_chung.vaccine",
                      "tiem_chung.quoc_gia_id","tiem_chung.so_giay_chung_nhan"];
      // this.$refs["myForm"].fields
      //   .find((f) => f.prop == "tiem_chung.anh_id")
      //   .resetField();
      this.fn_uploadRemoveAnh();
      if(loai == 1){
          this.mData.dataDefault.certificateByQR = false;
          this.mData.dataForm.tiem_chung.qr = null;
          propValid.forEach(key => {
            this.mData.validForm[key].push({
                                          required: true,
                                          message: "Please enter a value",
                                          trigger: "blur",
                                          });
          })
      console.log("this.mData.validForm",this.mData.validForm);
      }else if(loai == 2){
        this.mData.dataDefault.certificateByQR = true;
        this.mData.dataDefault.camera = 'auto';
        this.mData.dataForm.tiem_chung.qr = undefined;
        this.mData.dataDefault.showCamera = true;
        this.mData.dataForm.tiem_chung.anh_id = null;
        propValid.forEach(key => {
          this.mData.validForm[key] = this.mData.validForm[key].filter(validate => {return !validate.required});
        })
      }
      console.log("this.mData.validForm",this.mData.validForm);
      this.mData.dataForm.loai = loai;
      this.mData.dataForm.tiem_chung = {};
      this.mData.dataForm.tiem_chung = {
        luot_tiem: [
          {
            thoi_gian_tiem: null,
            dia_diem_tiem: null,
          }
        ],
        vaccine: null,
        gia_tri_den: null,
        so_giay_chung_nhan: null,
        anh_id: null,
        quoc_gia_id:null,
        qr: null,
        link: null,
      };
      this.$refs["myForm"].clearValidate();
      this.fn_changeVaccine();
    },
    fomartDate(date){
        let datearray = date.split("/");
        return datearray[1] + '/' + datearray[0] + '/' + datearray[2];
    },
    fn_submitForm() {
      console.log("this.mData.dataForm.loai",this.mData.dataForm.loai);
      let propValid = ["loai","tiem_chung.luot_tiem[0].thoi_gian_tiem","tiem_chung.luot_tiem[0].dia_diem_tiem",
                        "tiem_chung.luot_tiem[1].thoi_gian_tiem","tiem_chung.luot_tiem[1].dia_diem_tiem","tiem_chung.vaccine",
                      "tiem_chung.quoc_gia_id","tiem_chung.so_giay_chung_nhan","tiem_chung.anh_id","tiem_chung.qr"];
      if(this.mData.dataForm.loai == "1"){
        propValid.forEach(key => {
          this.mData.validForm[key].push({
                                        required: true,
                                        message: "Please enter a value",
                                        trigger: "blur",
                                        });
        })
      }else{
        propValid.forEach(key => {
          this.mData.validForm[key] = this.mData.validForm[key].filter(validate => {return !validate.required});
        })
      }
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          try {
            await ForeignerQrApi.submitDeclaration(this.mData.dataDefault.data.id,{});
            window.toastr.success("Submit successfully!");
            window.location.href = "/admin/TravelPass/QR";
            // this.$router.push("/admin/TravelPass/QR")
            
          } catch (error) {
            window.toastr.error("Submit failed!");
            return;
          }
        } else {
          MethodService.stopLadda();
          return;
        }
      });
    },
    async fn_saveData() {
      this.$refs["myForm"].clearValidate();
      if (this.checkSave()) {
        MethodService.stopLadda();
        return;
      }
      let propValid = ["loai","tiem_chung.luot_tiem[0].thoi_gian_tiem","tiem_chung.luot_tiem[0].dia_diem_tiem",
                        "tiem_chung.luot_tiem[1].thoi_gian_tiem","tiem_chung.luot_tiem[1].dia_diem_tiem","tiem_chung.vaccine",
                      "tiem_chung.quoc_gia_id","tiem_chung.so_giay_chung_nhan","tiem_chung.anh_id","tiem_chung.qr"];
        propValid.forEach(key => {
          this.mData.validForm[key] = this.mData.validForm[key].filter(validate => {return !validate.required});
        })
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let res ;
          let data = this.mData.dataDefault.data;
          if(this.mData.dataForm.tiem_chung.so_giay_chung_nhan){
            this.mData.dataForm.tiem_chung.so_giay_chung_nhan = this.mData.dataForm.tiem_chung.so_giay_chung_nhan.trim();
          }
          if(this.mData.dataForm.tiem_chung.luot_tiem.length > 0){
            for(let i = 0 ; i < this.mData.dataForm.tiem_chung.luot_tiem.length ; i++ ){
              if(this.mData.dataForm.tiem_chung.luot_tiem[i].dia_diem_tiem){
                this.mData.dataForm.tiem_chung.luot_tiem[i].dia_diem_tiem = this.mData.dataForm.tiem_chung.luot_tiem[i].dia_diem_tiem.trim(); 
              }
            }
          }
          if(!this.mData.dataForm.y_te.than_nhiet){
            this.mData.dataForm.y_te.than_nhiet = null;
          }
          data.khai_bao["y_te"] = this.mData.dataForm.y_te;
          data.khai_bao["tiem_chung"] = this.mData.dataForm.tiem_chung;
          try {
            res = await ForeignerQrApi.update(data);
            console.log("res",res);
            window.toastr.success("Save successfully!");
            propValid.forEach(key => {
              this.mData.validForm[key].push({
                                              required: true,
                                              message: "Please enter a value",
                                              trigger: "blur"
                                            });
            })
            this.checkDifferenceValueByQR = false;
          } catch (error) {
            if(error.code == 400){
              window.toastr.error("The vaccination certificate has been used, please try again!");  
            }else{
              window.toastr.error("Save failed!");
            }
            return;
          }
          if (res.result) {
            this.mData.dataDefault.data = JSON.parse(JSON.stringify(data));
            this.$forceUpdate();
            // this.fillData();
            return;
          } else {
            toastr.error("An error occurred!");
            return;
          }
        } else {
          propValid.forEach(key => {
              this.mData.validForm[key].push({
                                              required: true,
                                              message: "Please enter a value",
                                              trigger: "blur"
                                            });
            })
          MethodService.stopLadda();
          return;
        }
      });
    },

    checkSave() {
      if (
        !this.mData.dataDefault.data ||
        !this.mData.dataDefault.data.khai_bao ||
        (this.mData.dataDefault.data.khai_bao &&
          (!this.mData.dataDefault.data.khai_bao.y_te ||
            !this.mData.dataDefault.data.khai_bao.tiem_chung))
      ) {
        return false;
      } else if (this.checkDifference()) {
        return true;
      } else {
        return false;
      }
    },
    checkSubmit() {
      if (
        !this.mData.dataDefault.data ||
        !this.mData.dataDefault.data.khai_bao ||
        (this.mData.dataDefault.data.khai_bao &&
          (!this.mData.dataDefault.data.khai_bao.y_te ||
            !this.mData.dataDefault.data.khai_bao.tiem_chung))
      ) {
        return true;
      } else if (this.checkDifference()) {  
        return false;
      } else {
        return true;
      }
    },
    checkDifference() {
      let checkDif = 0;
      if(this.checkDifferenceValueByQR == true){
        return false;
      }
      for (let key of Object.keys(this.mData.dataForm)) {
        if (typeof this.mData.dataForm[key] == "object") {
          for (let keyC of Object.keys(this.mData.dataForm[key])) {
            if (
              typeof this.mData.dataForm[key][keyC] == "object" &&
              keyC == "luot_tiem"
            ) {
              for (let keyG of Object.keys(this.mData.dataForm[key][keyC])) {
                if(
                  this.mData.dataDefault.data.khai_bao[key][keyC][keyG] == undefined || 
                    this.mData.dataDefault.data.khai_bao[key][keyC][keyG] == undefined
                ){
                  checkDif += 1;
                }
                else if (
                  this.mData.dataForm[key][keyC][keyG].dia_diem_tiem !=
                    this.mData.dataDefault.data.khai_bao[key][keyC][keyG]
                      .dia_diem_tiem ||
                  this.mData.dataForm[key][keyC][keyG].thoi_gian_tiem !=
                    this.mData.dataDefault.data.khai_bao[key][keyC][keyG]
                      .thoi_gian_tiem 
                ) {
                  checkDif += 1;
                }
              }
            } else if (key == "y_te" && keyC != "than_nhiet") {
              if (
                this.checkDifferenceArray(
                  this.mData.dataForm[key][keyC],
                  this.mData.dataDefault.data.khai_bao[key][keyC]
                )
              ) {
                checkDif += 1;
              }
            } else if (
              this.mData.dataForm[key][keyC] !=
              this.mData.dataDefault.data.khai_bao[key][keyC]
            ) {
              checkDif += 1;
            }
          }
        } else {
          if (
            key != "loai" &&
            this.mData.dataForm[key] !=
              this.mData.dataDefault.data.khai_bao[key]
          ) {
            checkDif += 1;
          }
        }
      }
      if (checkDif > 0) {
        return false;
      }
      return true;
    },

    async getData() {
      let data = await ForeignerQrApi.list({
        filters: "trang_thai:nin:da_xuat_canh,khong_hop_le",
      });
      if (data.result && data.result.length > 0) {
        this.mData.dataDefault.data = data.result[0];
        if(data.result[0].trang_thai == "moi"){
          this.$store.commit("fn_checkChangePassword");
        }
        if (
          data.result[0].trang_thai &&
          [
            "cho_cap_visa",
            "cho_nhap_visa",
            "cho_nhap_canh",
            "da_nhap_canh",
            "cho_duyet_vaccine"
          ].includes(data.result[0].trang_thai)
        ) {
          this.$router.push("/admin/TravelPass/QR");
        }else if (
          this.mData.dataDefault.data.khai_bao &&
          this.mData.dataDefault.data.khai_bao.y_te &&
          this.mData.dataDefault.data.khai_bao.tiem_chung
        ) {
          this.fillData();
        }
      } else {
        // toastr.error("An error occurred!");
        let data = await ForeignerQrApi.create({});
        if (data.result) {
          this.mData.dataDefault.data = { id: data.result, khai_bao: {} };
        }
      }
    },
    fillData() {
      let data = JSON.parse(
        JSON.stringify(this.mData.dataDefault.data.khai_bao)
      );
      console.log("this.mData.dataForm before",this.mData.dataForm);
      for (let key of Object.keys(this.mData.dataForm)) {
              // debuggerS
        if (typeof this.mData.dataForm[key] == "object") {
          for (let keyC of Object.keys(this.mData.dataForm[key])) {
            this.mData.dataForm[key][keyC] = data[key][keyC];
            if (keyC == "anh_id" && this.mData.dataForm[key][keyC]) {
              this.mData.dataDefault.anh =
                window.MyConfig.hostApi +
                "file/thumb?id=" +
                this.mData.dataForm[key][keyC];
            }
          }
        } else {
          this.mData.dataForm[key] = data[key];
        }
      }
      if(!this.mData.dataForm.tiem_chung.anh_id && !this.mData.dataForm.tiem_chung.qr){
        this.mData.dataForm.loai = 1;
      }
      if (this.mData.dataForm.tiem_chung.anh_id) {
        this.mData.dataForm.loai = 1;
      } else if (this.mData.dataForm.tiem_chung.qr) {
        this.mData.dataForm.loai = 2;
        this.mData.dataDefault.certificateByQR = true;
        this.mData.dataDefault.showCamera = false;
      } else if (this.mData.dataForm.tiem_chung.link) {
        this.mData.dataForm.loai = 3;
      }
      if(this.mData.dataForm.y_te.than_nhiet == "0"){
        this.mData.dataForm.y_te.than_nhiet = null;
      }
      
      console.log("this.mData.dataForm",this.mData.dataForm);
    },
    renderTimes(i) {
      if (i == 0) {
        return "1st";
      } else if (i == 1) {
        return "2nd";
      } else if (i == 2) {
        return "3rd";
      } else {
        return i + 1 + "th";
      }
    },
    fn_changeVaccine() {
      let vaccine = this.mData.dataDefault.listVaccine.find(
        (vac) => vac.id == this.mData.dataForm.tiem_chung.vaccine
      );
      if(vaccine == undefined){
            vaccine = {};
            vaccine.so_lan_tiem = 1;
        }
      if (vaccine && vaccine.so_lan_tiem) {
        if (
          this.mData.dataForm.tiem_chung.luot_tiem.length > vaccine.so_lan_tiem
        ) {
          this.mData.dataForm.tiem_chung.luot_tiem.splice(
            vaccine.so_lan_tiem,
            this.mData.dataForm.tiem_chung.luot_tiem.length -
              vaccine.so_lan_tiem
          );

          for (
            let i = vaccine.so_lan_tiem;
            i < this.mData.dataForm.tiem_chung.luot_tiem.length;
            i++
          ) {
            delete this.mData.validForm[
              "tiem_chung.luot_tiem[" + i + "].thoi_gian_tiem"
            ];
            delete this.mData.validForm[
              "tiem_chung.luot_tiem[" + i + "].dia_diem_tiem"
            ];
          }
        } else {
          while (
            this.mData.dataForm.tiem_chung.luot_tiem.length <
            vaccine.so_lan_tiem
          ) {
            this.mData.dataForm.tiem_chung.luot_tiem.push({
              thoi_gian_tiem: null,
              dia_diem_tiem: "",
            });
            this.mData.validForm[
              "tiem_chung.luot_tiem[" +
                (this.mData.dataForm.tiem_chung.luot_tiem.length - 1) +
                "].thoi_gian_tiem"
            ] = [
              {
                required: true,
                message: "Please enter a value",
                trigger: "blur",
              },
              {
                validator: this.validateNgayHetHan,
                trigger: "blur",
              },
            ];
            this.mData.validForm[
              "tiem_chung.luot_tiem[" +
                (this.mData.dataForm.tiem_chung.luot_tiem.length - 1) +
                "].dia_diem_tiem"
            ] = [
              {
                required: true,
                message: "Please enter a value",
                trigger: "blur",
              },
              ValidService.checkSpaceString
            ];
          }
        }
      }
    },
    
    validateNgayHetHan1(rule, value, callback) {
        if(!value){
            callback();
            return;
        }
        if (new Date(value).getTime() <= new Date().getTime()) {
            callback(new Error("Expiry date must be after today’s date"));
            return;
        }
        callback();
        return;
    },

    validateNgayHetHan(rule, value, callback) {
      if (value != "" && (new Date(value).getTime() >= new Date().getTime())) {
        callback(new Error("Injection time must be earlier than today"));
        return;
      }
      if (
        this.mData.dataForm.tiem_chung.gia_tri_den &&
        new Date(this.mData.dataForm.tiem_chung.gia_tri_den).getTime() <=
          new Date(value).getTime()
      ) {
        callback(new Error("Date of expiry must be later than Injection time"));
        return;
      }

      let index = Number(rule.field.match(/\d/)[0]);
      if (index == 0) {
        callback();
        return;
      }
      for (let i = 0; i < index; i++) {
        if(!this.mData.dataForm.tiem_chung.luot_tiem[1].thoi_gian_tiem){
          callback();
          return;
        }
        else if (
          value != "" &&
          (this.mData.dataForm.tiem_chung.luot_tiem[i].thoi_gian_tiem &&
          new Date(
            this.mData.dataForm.tiem_chung.luot_tiem[i].thoi_gian_tiem
          ).getTime() >= new Date(value).getTime())
        ) {
          callback(
            new Error(
              "Next injection time must be later than previous injection time"
            )
          );
          return;
        }
      }
      callback();
      return;
    },
    checkDifferenceArray(array1, array2) {
      let difItem = array1.filter((item) => {
        return !array2.includes(item);
      });
      if (array1.length == array2.length && difItem.length == 0) {
        return false;
      } else {
        return true;
      }
    },
    forceUpdateUI() {
      this.$forceUpdate();
    }
  },
  created(){
    this.mData.dataForm.loai = 1;
  },
  mounted() {
    this.mData.dataForm.loai = 1;
    this.initData();
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: UTM-Cafeta;
  src: url(/fonts/UTM_Cafeta.ttf);
}
@font-face {
  font-family: MYRIADPRO-REGULAR;
  src: url(/fonts/MYRIADPRO-REGULAR.OTF);
}
.hide {
  ::v-deep.el-upload.el-upload--text {
    display: none;
  }
}
.main-card-header{
  position: fixed;
  top: 60px;
  width: 100%;
  height: 43px;
  z-index : 3;
  background-color: #cdf3f8;
  border-color: #cdf3f8;
  display: flex;
  align-items: center;
}
.main-card-header span{
  font-family: MYRIADPRO-REGULAR;
  color: #0c66ad;
  font-weight: 600;
}
.title{
  color: #17b5ee;
  font-family: MYRIADPRO-REGULAR;
  font-weight: 600;
}
.main-card-body{
  position: relative;
  top: 43px;
}
.btn-save{
  background-color: #0c66ad;
  border-color: #0c66ad;
  color: #ade0eb;
}
.btn-save:hover{
  background-color: #0c66ad;
  border-color: #0c66ad;
  color: #ade0eb;
}
.btn-submit{
  background-color: #ade0eb;
  border-color: #ade0eb;
  color: #0c66ad;
}
.btn-submit:hover{
  background-color: #ade0eb;
  border-color: #ade0eb;
  color: #0c66ad;
}
::v-deep .el-collapse-item__header{
  color: #0c66ad;
  font-family: MYRIADPRO-REGULAR;
  font-weight: 600;
}
::v-deep .el-form-item__label{
  color: #0c66ad;
  font-family: MYRIADPRO-REGULAR;
  font-weight: 600;
}
::v-deep img {
  object-fit: contain;
  object-position: center;
}
::v-deep .el-button.is-disabled:hover{
  cursor: not-allowed;
}
::v-deep .text-center input{
  text-align: center;
}
@media (min-width: 1200px) {
  .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 639px) {
  .el-select-dropdown__item.custom-select-break-line {
    height: auto;
    overflow: initial;
    white-space: normal;
  }
}
@media (min-width: 991px) and (max-width: 1148px) {
  ::v-deep .el-upload-dragger{
    width: 280px;
  }
}
@media (min-width: 388px) and (max-width: 450px) {
  ::v-deep .el-upload-dragger{
    width: 293px;
  }
}
@media (min-width: 320px) and (max-width: 388px) {
  ::v-deep .el-upload-dragger{
    width: 228px;
  }
}
</style>